import { connect } from 'react-redux'

import {
  doUpdateTrelloCard,
  doUnlinkTrelloCard,
  selectCurrentTicketLinkedCards,
} from 'ducks/integrations/trello'
import { selectIntegrationSettingsSidebarFieldsToDisplayForProvider } from 'ducks/integrations'

import TrelloInAppCard from './view'

const select = state => ({
  cards: selectCurrentTicketLinkedCards(state),
  fieldsToDisplay: selectIntegrationSettingsSidebarFieldsToDisplayForProvider(
    state,
    {
      provider: 'trello',
    }
  ),
})

const performFactory = (dispatch, { card: { id } }) => {
  return {
    onArchive: () => dispatch(doUpdateTrelloCard(id, { closed: true })),
    onSendToBoard: () => dispatch(doUpdateTrelloCard(id, { closed: false })),
    onUnlink: () => dispatch(doUnlinkTrelloCard(id)),
  }
}

export default connect(select, performFactory)(TrelloInAppCard)
